import { motion, Variants } from "framer-motion";
import { AnimationDefinition } from "framer-motion/types/render/utils/animation";
import { useContext } from "react";
import styled from "styled-components";
import { TimelineAnimateScrollContext } from "../../context/TimlineAnimateScrollContext";
import { Color } from "../../models/theme";
import { easings, fill } from "../../styles/utils";
import { Box } from "../Box";
import { Portal } from "../Portal";

interface TimelineScrollAnimatorProps {}

const Wrapper = styled(motion(Box))`
  ${fill("fixed")}
  z-index: 2;
  pointer-events: none;
`;

const variants: Variants = {
  hidden: {
    opacity: 0,
    transition: { duration: 1, ease: easings.easeInCubic },
  },
  animating: {
    opacity: 1,
    transition: { duration: 0.6, delay: 0.3, ease: easings.easeInCubic },
  },
};

export const TimelineScrollAnimator: React.FC<
  TimelineScrollAnimatorProps
> = ({}) => {
  const {
    state: { isAnimating, color },
    setIsAnimating,
  } = useContext(TimelineAnimateScrollContext);

  const handleAnimationComplete = (def: AnimationDefinition) => {
    if (def === "animating") {
      setTimeout(() => {
        setIsAnimating({ isAnimating: false, color });
      }, 800);
    }
  };

  return (
    <Portal>
      <Wrapper
        id="scroll-animator"
        initial={false}
        animate={isAnimating ? "animating" : "hidden"}
        variants={variants}
        backgroundColor={color}
        onAnimationComplete={handleAnimationComplete}
      />
    </Portal>
  );
};
